import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32e63be2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=32e63be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e63be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e63be2')) {
      api.createRecord('32e63be2', component.options)
    } else {
      api.reload('32e63be2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32e63be2&scoped=true&", function () {
      api.rerender('32e63be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbon-removal/views/index.vue"
export default component.exports